import { render, staticRenderFns } from "./AsyncIframe.vue?vue&type=template&id=44e16492&"
import script from "./AsyncIframe.vue?vue&type=script&lang=js&"
export * from "./AsyncIframe.vue?vue&type=script&lang=js&"
import style0 from "./AsyncIframe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports